// extracted by mini-css-extract-plugin
export default {"wrapper":"ApptButtons_wrapper__ugnyk"};